import styled from "styled-components";

import { ICON_HEIGHT } from "./_constants";

const IconChangePassword = styled.img.attrs({
  src: "/assets/images/icon-chage-password.png",
  alt: "Change Password",
  title: "Change Password"
})`
  cursor: pointer;
  height: ${ICON_HEIGHT}px;
`;
IconChangePassword.displayName = "ChangePassword";

export default IconChangePassword;
